import React from 'react'
import ReactDOM from 'react-dom'
import App from './app/App'
import { Provider } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import * as serviceWorker from './serviceWorker'
import rootReducer from './features/reducer'
import { BrowserRouter, Route } from "react-router-dom"

const store = configureStore({
  reducer: rootReducer,
})

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={'/portfolio'}>
      <Route path="/" component={App} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

serviceWorker.unregister()
